export const staircaseConfig = {
    gameSlug: 'prospective-memory',
    category: 'eau_memoire',
    variable: 'duration_ms',
    startValue: 1500,
    minValue: 600,
    maxValue: 2400,
    stepSizesByPhase: [200, 100, 50, 25],
    reversalsToConverge: 4,
    reversalsForThreshold: 3,
    /** Bloc court — chaque trial = 1 ongoing. */
    maxTrials: 28,
    direction: 'down-easier',
};
function buildVariant(level) {
    if (level <= 10) {
        return {
            level,
            cueRule: 'is-7',
            pmCueRatio: 0.18,
            nIntentions: 1,
            label: 'PM focal',
        };
    }
    if (level <= 20) {
        return {
            level,
            cueRule: 'div-by-4',
            pmCueRatio: 0.20,
            nIntentions: 1,
            label: 'PM non-focal',
        };
    }
    if (level <= 30) {
        return {
            level,
            cueRule: 'is-7-or-3',
            pmCueRatio: 0.22,
            nIntentions: 2,
            label: '2 intentions',
        };
    }
    if (level <= 40) {
        return {
            level,
            cueRule: 'is-7-or-3',
            pmCueRatio: 0.20,
            nIntentions: 2,
            label: 'Délai long',
        };
    }
    return {
        level,
        cueRule: 'is-7-or-3',
        pmCueRatio: 0.22,
        nIntentions: 2,
        label: 'Time-based mix',
    };
}
export const levels = Array.from({ length: 50 }, (_, i) => buildVariant(i + 1));
export function variantForLevel(level) {
    const idx = Math.max(1, Math.min(50, level)) - 1;
    return levels[idx];
}
/**
 * Vérifie si un digit est un cue PM selon la règle courante.
 * Exporté pour usage tests + UI (rappel visuel de la consigne).
 */
export function isCueDigit(digit, rule) {
    switch (rule) {
        case 'is-7':
            return digit === 7;
        case 'div-by-4':
            return digit !== 0 && digit % 4 === 0;
        case 'is-7-or-3':
            return digit === 7 || digit === 3;
    }
}
/**
 * Pour affichage, renvoie le label humain de la consigne PM courante.
 */
export function cueRuleLabel(rule) {
    switch (rule) {
        case 'is-7':
            return 'Tape PM si le chiffre est 7.';
        case 'div-by-4':
            return 'Tape PM si le chiffre est 4 ou 8.';
        case 'is-7-or-3':
            return 'Tape PM si le chiffre est 3 ou 7.';
    }
}
export const timing = {
    fixationMs: 300,
    feedbackMs: 200,
    /** Fenêtre de réponse maximale après affichage du chiffre. */
    responseWindowMs: 2500,
};
export const paradigmMeta = {
    slug: 'prospective-memory',
    paradigm: 'Prospective Memory (Einstein & McDaniel 1990)',
    /** Internal only — non affiché. */
    masterMage: 'Ondine · Inori',
    category: 'eau_memoire',
    goal: "Tâche en cours plus déclencher l'action prévue au bon moment.",
};
//# sourceMappingURL=params.js.map